import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ProfileLazy = lazyLoader(
  () => import('./Profile' /* webpackChunkName: "profile" */),
);

const Profile = () => {
  return (
    <Suspense fallback={null}>
      <ProfileLazy />
    </Suspense>
  );
};

export default Profile;
